import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

// Initialize PostHog
if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    person_profiles: "identified_only", // Only create profiles for identified users
    capture_pageview: true, // Automatically capture pageviews
    capture_pageleave: true, // Capture when users leave pages
    autocapture: {
      dom_event_allowlist: ["click"], // Only capture click events by default
      url_allowlist: [], // Allow all URLs
    },
  });

  // Enable error tracking
  posthog.startSessionRecording(); // Optional: enable session replay for debugging
}

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
);
